/** Einheitlicher Anzeigetext für Akku-Auswahllisten: „Bezeichnung (Besitzer)“. */
export function akkuAnzeige(a: { id?: number; bezeichnung?: string | null; seriennummer?: string | null; besitzer_label?: string | null; besitzer_name?: string | null }): string {
  const name = a.bezeichnung || a.seriennummer || (a.id ? `Akku #${a.id}` : 'Akku')
  return `${name} (${a.besitzer_name || a.besitzer_label || 'ASB-Drohnenstaffel'})`
}
